
export default {
    namespaced: true,

    state: () => ({
        stores: []
    }),

    getters: {
        stores: state => state.stores,
    },

    mutations: {
        setStores: (state, stores  = []) => {
            state.stores = stores;
        },
    },

    actions: {
        loadStores({ commit }, { cityId, sort } = {}) {
            return this.$api.loadStores({ cityId, sort })
                .then(stores => {
                    commit('setStores', stores);
                })
                .catch((err) => {
                    throw err;
                });
        },
    }
};
